import { combineReducers } from 'redux'
import {languageReducer} from './lang'
import { printers, printersHasError, printersIsLoading, printersCache} from './printers';
import { emailreports, emailReportsHasError, emailReportsIsLoading} from './emailreports';
import { users, usersHasError, usersIsLoading, usersCache} from './users';
import { computers, computersHasError, computersIsLoading, computersCache} from './computers';
import { servers, serversHasError, serversIsLoading, serversCache} from './servers';
import { usergroups, usergroupsHasError, usergroupsIsLoading, usergroupsCache} from './usergroups';
import {reportFilterReducer} from './reportfilter'
import { license } from './license';
import { serverVersion } from './serverVersion';
import { compgroups, compgroupsHasError, compgroupsIsLoading, compgroupsCache} from './compgroups';

export const initialState = {}
  
  export const rootReducer = combineReducers({
    language: languageReducer,
    printers,
    printersHasError,
    printersIsLoading,
    printersCache,
    emailreports,
    emailReportsHasError,
    emailReportsIsLoading,
    users,
    usersHasError,
    usersIsLoading,
    usersCache,
    computers,
    computersHasError,
    computersIsLoading,
    computersCache,    
    usergroups,
    usergroupsHasError,
    usergroupsIsLoading,
    usergroupsCache,
    reportFilter: reportFilterReducer,
    servers,
    serversHasError,
    serversIsLoading,
    serversCache,
    license,
    serverVersion,
    compgroups,
    compgroupsHasError,
    compgroupsIsLoading,
    compgroupsCache
  })